import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAppConfig, getAppData } from '../actions/appActions';
import { setMenuOpen, setShareWidgetOpen, setFrameContext } from '../actions/uiActions';
import { getGeoData } from '../actions/geoDataActions';
import Transition from 'react-transition-group/Transition';
import GoogleTagManager from './GoogleTagManager';
import MetaData from './MetaData';
import Header from './Header';
import MainNav from './MainNav';
import MainNavMobile from './MainNavMobile';
import ShareWidget from './ShareWidget';
import Error404 from './Error404';
import ErrorBoundary from './ErrorBoundary';
import Section from './Section';


class App extends Component {
  constructor (props) {
    super(props);
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleNavIconClick = this.handleNavIconClick.bind(this);
    this.handleShareIconClick = this.handleShareIconClick.bind(this);
    this.handleShareAction = this.handleShareAction.bind(this);
  }

  componentDidMount () {
    const { actions } = this.props;
    actions.getAppConfig();
    actions.getAppData();
    actions.setFrameContext();
  }

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line camelcase
    const { actions: { getGeoData }, config } = this.props;
    const nextConfig = nextProps.config;

    if (!isEqual(config.geoDataSets, nextConfig.geoDataSets)) {
      nextConfig.geoDataSets.map(item => getGeoData(item));
    }
  }

  handleMenuItemClick () {
    const { actions } = this.props;
    actions.setMenuOpen(false);
  }

  handleNavIconClick () {
    const { actions } = this.props;
    actions.setMenuOpen(true);
  }

  handleShareIconClick () {
    const { actions, ui } = this.props;
    actions.setShareWidgetOpen(!ui.shareWidgetIsOpen);
  }

  handleShareAction () {
    const { actions } = this.props;
    actions.setShareWidgetOpen(false);
  }

  renderDefaultRoutes () {
    const { sections } = this.props;
    return (
      <Switch>
        <Route exact path="/" render={props => (
          <Redirect to={`/1/${sections.navItems[0]}`} />
        )} />

        <Route path="/:seq(\d{1,2})/:slug" render={props => {
          if (Object.keys(sections).length === 0) {
            return null;
          }

          const { seq, slug } = props.match.params;
          const sectionData = sections.bySlug[slug];
          const order = parseInt(seq, 10);
          if (!sectionData || sections.navItems[order - 1] !== slug) {
            return <Error404 />;
          }

          return (
            <Section
              routeProps={props}
              title={sectionData.name}
              slug={sectionData.slug}
              socialImage={sectionData.socialImage}
              order={order}
              description={sectionData.description}
              content={sectionData.items}
            />
          );
        }} />
        <Route exact path="/error" render={props => { throw new Error('Test error'); }} />
        <Route component={Error404} />
      </Switch>
    );
  }

  render () {
    const { ui, breakpoint, location, config, project, sections } = this.props;
    const { isEmbedded, parentUrl, embeddedUrl } = ui;
    const dataLayerVars = {
      embed: { isEmbedded, parentUrl, embeddedUrl },
    };

    if (!Object.keys(config).length || !Object.keys(sections).length) {
      return <div className="h-100 loading-spinner-50" />;
    }

    return (
      <div className={`app-container${ui.fullHeight ? ' full-height' : ''}`}>
        { project.analyticsProvider === 'gtm' && project.analyticsId ? (
          <GoogleTagManager gtmId={project.analyticsId} additionalEvents={dataLayerVars} />
        ) : null}
        <MetaData />

        {breakpoint.lessThan.lg
          ? (
            <MainNavMobile
              show={ui.menuIsOpen}
              path={location.pathname}
              project={project}
              sections={sections}
              onCloseClick={this.handleMenuItemClick}
              onSocialShare={this.handleMenuItemClick}
            />
          ) : null
        }

        <section className="app-header">
          <Header
            project={project}
            shareWidgetOpen={ui.shareWidgetIsOpen}
            onNavIconClick={this.handleNavIconClick}
            onShareIconClick={this.handleShareIconClick}
          />
          <MainNav sections={sections} subnavOnly={breakpoint.lessThan.lg} />
          <Transition in={ui.shareWidgetIsOpen} timeout={100} mountOnEnter unmountOnExit>
            {state => (
              <ShareWidget transitionState={state} onTriggerShare={this.handleShareAction} />
            )}
          </Transition>
        </section>

        <main className="app-main">
          <ErrorBoundary>
            <Route render={({ location }) => {
              // Remove trailing slash, preserving query params
              if (location.pathname.endsWith('/') && location.pathname !== '/') {
                return <Redirect to={location.pathname.slice(0, -1) + location.search} />;
              }

              // Check for global error state
              return (
                location.state && location.state.is404
                  ? <Error404 />
                  : this.renderDefaultRoutes()
              );
            }} />
          </ErrorBoundary>
        </main>
      </div>
    );
  }
}

App.propTypes = {
  config: PropTypes.object,
  sections: PropTypes.object,
  messages: PropTypes.arrayOf(PropTypes.shape({
    level: PropTypes.string,
    text: PropTypes.string,
    id: PropTypes.number,
  })),
  actions: PropTypes.object,
  location: PropTypes.object,
};

const mapStateToProps = ({ ui, breakpoint, config, project, sections, globalMessages }) => ({
  ui,
  breakpoint,
  config,
  project,
  sections,
  messages: globalMessages,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ getAppConfig, getAppData, setMenuOpen, setShareWidgetOpen, setFrameContext, getGeoData }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App.js